import React from 'react';
import "react-lazy-load-image-component/src/effects/blur.css";
import '../../Pages/Homepage.css';
import Navbar from '../../commonComponents/Navbar';
import CorporateBanner from '../../Componentsss/Coporate-travel-management/CorporateBanner/CorporateBanner';
import Empowering from '../../Componentsss/Coporate-travel-management/EmpoweringSection/Empowering';
import ServiceOffering from '../../Componentsss/Coporate-travel-management/ServiceOffering/ServiceOffering';
import TravelServices from '../../Componentsss/Coporate-travel-management/TravelServices/TravelServices';
import TailoredTravelSolutions from '../../Componentsss/Coporate-travel-management/TailoredTravew-Solutions/TailoredTravelSolutions';
import Compherensive from '../../Componentsss/Coporate-travel-management/Compherensive/Compherensive';
import ConnectForm from '../../Componentsss/Contactus/ConnectForm/ConnectForm';
import Footer from '../../commonComponents/Footer';
import { useState } from 'react';

const CorporateTravelManagement = () => {
  // Wait until the banner signals that the first image has loaded.
  const [bannerLoaded, setBannerLoaded] = useState(false)
  return (
    <>
    {bannerLoaded && <Navbar />}
    <CorporateBanner onLoad={() => setBannerLoaded(true)} />
    {bannerLoaded && (
      <>
        <Empowering />
        <ServiceOffering />
        <TravelServices />
        <TailoredTravelSolutions />
        <Compherensive />
        <ConnectForm />
        <Footer />
      </>
    )}
    
    </>
  )
}

export default CorporateTravelManagement
